// extracted by mini-css-extract-plugin
export default {"mainContainer":"LayoutDashboardPage_mainContainer__g9NbF"};